<template>
	<div id="mycenter">
		<div class="mycenter_info">
			<div class="imgbox">
				<img  v-show="!teamForm.Photo" class="Photo" src="../assets/zanwu.jpg" alt="">
				<img  v-show="teamForm.Photo" class="Photo" :src="teamForm.RootPath+teamForm.Photo" alt="">
			</div>
			<div class="info">
				<div class="name" v-text="teamForm.TeamName"></div>
				<div class="Org">
					<div class="title">机构名称</div>
					<div v-text='teamForm.TeamOrg||"未填写"'></div>
				</div>
				<div class="area">
					<div class="title">所在地区</div>
					<div v-text="teamForm.Province+'-'+teamForm.City"></div>
				</div>
				
			</div>
		</div>
		
		<div class="list">
			<div class="title">参赛宣言：</div>
			<div class="text" v-text="teamForm.TeamDeclaration||'未填写'"></div>
		</div>
		<div class="team_members">团队成员:</div>
		<div class="members" v-for="item in teamForm.Members">
			<div class="name"><span>姓名：</span>{{item.UserName}}</div>
			<div><span>所持证书：</span>{{item.CertIds || '暂无证书'}}</div>
		</div>
		<h1 class="resume_title">团队简介</h1>
		<textarea readonly="readonly" class="resume" :value='teamForm.Introduction||"未填写"'></textarea>
		<div style="height: 40px;"></div>
		<div class="operation" v-if="teamForm.IsCaptain" @click="$router.push('/editTeam')">
			修改团队信息
		</div>
	</div>
</template>

<script>
	import { MessageBox } from 'mint-ui';

	export default{
		data(){
			return{
				teamForm:{
					TeamName:'',
					TeamOrg:'',
					MemberMobiles:[]
				},
			}
		},
		created(){
			
			// localStorage.removeItem("competition_cookie")
			var competition_cookie = localStorage.getItem("competition_cookie")
			console.log(competition_cookie)
			if(competition_cookie){
				this.getmember()
			}else{
				MessageBox('提示', '请先登录！');
				this.$router.push('/login');
				
			}
			
		},
		methods:{
			getmember(){
				this.$http.get('/api/team/GetOrg')
				.then(res => {
					for(let x in res.data.data.Members){
						console.log(res.data.data.Members[x].CertIds)
						var reg =/[\u4e00-\u9fa5]/g;
						var str = res.data.data.Members[x].CertIds?res.data.data.Members[x].CertIds:'';
						 res.data.data.Members[x].CertIds = str.replace(reg, "");
					}
					this.teamForm = res.data.data
					console.log(this.teamForm)
				})
				.catch(error => {
				  console.log(error)
				})
			},
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#mycenter{
		padding:1rem 0.8rem;box-sizing: border-box;
		.team_members{
			margin: 20px 0;
			font-size: 1rem;
		}
		.members{
			margin-top:20px;
			font-size: 0.9rem;
			.name{
				margin-bottom: 10px;
			}
		}
		.mycenter_info{
			display: flex;
			.imgbox{
				width: 7.5rem;
				height: 9rem;
				background: #dbdcdd;
				display: flex;align-items: center;
				.Photo{
					width:100%;
					
				}
			}
			.info{
				flex: 1;
				height: 9rem;
				padding-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.Org,.area,.time{display: flex;font-size: 0.9rem;
					.title{
						margin-right: 1rem;
						color: #2c3e50;
						white-space: nowrap; 
					}
					div{color: #666}
				}
				.name{font-size: 1.1rem;margin: 20px 0;}
			}
		}
		.list{
			display: flex;
			font-size:0.9rem;
			margin-top: 1rem;
			line-height: 1.4rem;
			.title{
				white-space: nowrap;
				color: #2c3e50;
			}
			div{color: #666}
		}
		.resume_title{text-align: center;font-size: 1.1rem;margin: 2rem 0 1rem 0}
		.resume{color: #666;font-size: 0.9rem;line-height: 1.4rem;width: 100%;border: none;height: 400px}
		.operation {
			position: fixed;
			width: 100%;
			height: 40px;
			line-height: 40px;
			background: #3E1976;
			bottom: 0;
			left: 0;
			color: #fff;
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/myTeam.vue